module.exports = __webpack_public_path__ + "img/people-black.b2803a36.svg";